export default __webpack_public_path__ + "static/media/coach_ok.14faa0fc.png";